import * as React from "react";
import UserProfile from "../../containers/UserProfile/UserProfile";
import { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { RouteComponentProps } from "react-router-dom";
import { State } from "../../reducers";
import { CommonUser } from "../../types";
import LoadingSegment from "../../components/LoadingSegment/LoadingSegment";
import ProfileTopSection from "../../components/Profile/ProfileTopSection/ProfileTopSection";

interface RouteParams {
    id?: string;
}

interface ProfileProps extends RouteComponentProps<RouteParams> {
    user: CommonUser;
    dispatch: Dispatch<any>;
}

interface ProfileState {
    id: number;
    loading: boolean;
}

const mapStatetoProps = (state: State) => ({
    user: state.authentication.user,
});

class Profile extends Component<ProfileProps, ProfileState> {
    state = {
        id: 0,
        loading: true
    };

    componentWillReceiveProps(nextProps: ProfileProps) {
        if (nextProps.match.params.id) {
            if (parseInt(nextProps.match.params.id) !== this.state.id) {
                this.setState({id: parseInt(nextProps.match.params.id), loading: false });
            }
        } else {
            if (this.props.user.id !== this.state.id) {
                this.setState({id: this.props.user.id, loading: false });
            }
        }
    }

    componentWillMount() {
        let id = this.props.match.params.id ? parseInt(this.props.match.params.id) : this.props.user.id;
        this.setState({ id: id, loading: false });
    }

    render() {
        return (
            <LoadingSegment isLoading={this.state.loading}>
                <UserProfile userId={this.state.id.toString()} />
            </LoadingSegment>
        );
    }
}

export default connect(mapStatetoProps)(Profile);